export const validateDateFormat = (value) => {
	if (!value) return 'This is not a valid date format';

	const [month, day, year] = value.split('/').map(Number);

	const isValid =
		year > 1800 &&
		year <= new Date().getFullYear() &&
		day >= 1 &&
		day <= 31 &&
		month >= 1 &&
		month <= 12;

	return isValid || 'This is not a valid date format';
};

export const validateAge = (value) => {
	if (!value) return true;

	const [month, day, year] = value.split('/').map(Number);
	const birthDate = new Date(year, month - 1, day);
	const today = new Date();

	let age = today.getFullYear() - birthDate.getFullYear();
	const m = today.getMonth() - birthDate.getMonth();

	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
		age--;
	}

	if (age < 17) return 'Age must be 17 or older';
	if (age > 126) return 'Age must be 126 or less';

	return true;
};

export const emailValidator = {
	value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i,
	message: 'This is not a valid email format',
};

export const phoneValidator = {
	value: /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/,
	message: 'This is not a valid phone format',
};
